import React from "react";

import RankingsGroupWidget from "./RankingsGroupWidget";

export default function RankingsWidget(props) {
  const { rankingGroups, leagueId, regionId, embed, ...rest } = props;

  return (
    <>
      {rankingGroups &&
        rankingGroups.map((rankingGroup, index) => {
          return (
            <RankingsGroupWidget
              key={index}
              league={rankingGroup}
              leagueId={leagueId || rankingGroup.id}
              regionId={regionId}
              isGameSystem={!leagueId}
              embed={embed}
              {...rest}
            />
          );
        })}
    </>
  );
}
